<template>
  <span>
    <span
      v-if="parsedMinutes != 0"
    >
      {{ parsedMinutes }} minute{{ minutesSuffix }}
    </span>
    <span
      v-if="parsedSeconds != 0"
    >
      {{ parsedSeconds }} second{{ secondsSuffix }}
    </span>
  </span>
</template>

<script>
export default {
  name: 'SecondsToMinutes',
  props: {
    seconds: {
      type: Number,
      default: () => 0,
    },
  },
  computed: {
    parsedMinutes() {
      return Math.floor(this.seconds / 60);
    },
    minutesSuffix() {
      return this.parsedMinutes === 1 ? '' : 's';
    },
    parsedSeconds() {
      return this.seconds % 60;
    },
    secondsSuffix() {
      return this.parsedSeconds === 1 ? '' : 's';
    },
  },
};
</script>
